import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette, spacing }) => ({
  background: {
    gridArea: "Banner",
    margin: `${spacing(10)}px 0`,
    backgroundColor: "transparent",
    position: "relative",
  },
  backgroundMob: {
    gridArea: "Banner",
    margin: `${spacing(10)}px 0`,
    backgroundColor: "transparent",
    position: "relative",
    minWidth: "100%",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    placeItems: "center",
  },
  containerMob: {
    display: "grid",
    placeItems: "center",
  },
  image: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    width: "486px",
    height: "486px",
    borderRadius: "50%",
    backgroundColor: palette.secondary.main,
  },
  empty: {
    position: "absolute",
    right: "-5%",
    bottom: "-5%",
    width: "159px",
    height: "159px",
    border: "32px solid #62B47C;",
    borderRadius: "50%",
  },
  full: {
    position: "absolute",
    right: "-5%",
    bottom: "-5%",
    width: "248px",
    height: "248px",
    backgroundColor: "#62B47C;",
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
  },
  circleText: {
    color: "#fff",
    fontWeight: 800,
    fontSize: "32px",
    lineHeight: "39px",
  },
  text: {
    display: "flex",
    flexDirection: "column",
  },
  textMob: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "20px",
  },
  title: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "#1A3154",
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "63px",
    textTransform: "uppercase",
  },
  paragraph: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "#5E6162",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "29px",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    fontSize: "2em",
  },
}));

export default useStyles;
